import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { LogEntry } from 'lib-shared-legacy-types';

import { getActivityLog } from '../api/activityLog';

const prefix = 'activity-log';

export const activityLogActions = {
  toggle: createAction<{ open: boolean }>(`${prefix}/toggle`),
  get: createAsyncThunk<{ entries: LogEntry[] }, { csid: number }>(
    `${prefix}/get`,
    async ({ csid }) => {
      const { data } = await getActivityLog(csid);
      return { entries: data.activity_log };
    },
  ),
};
